// NOTE: Make sure this styling is in sync with styles.ts
export const linkStyle = "l1iva7rb";
export const bodyRegularStyle = "bc1836r";

require("./linariaStyles.linaria.module.css!=!../../../node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js?cacheProvider=!./linariaStyles.ts");